import { FileType } from '@summit/core';
import { EboNameObject } from '../base-classes/ebo-name-object';
import { CompanySettlement } from './company-settlement';

export class SettlementFile extends EboNameObject {
  path: string;
  type: FileType;
  companySettlementID: string;
  companySettlement: CompanySettlement;
}
